<template>
  <div class="edit-user-account content-block">
    <div class="row">
      <div class="col-md-6">
        <div v-if="!isMyProfile" class="edit-user-block">
          <div class="edit-user-block__title">
            {{ $t("labels.fio") }}
          </div>
          <template v-if="!collapseVisible.fullName">
            <div class="edit-user-block__full-name">
              {{ user.getFullName() }}
            </div>
          </template>
          <div class="edit-user-block__collapse-link">
            <span
              @click="
                (collapseVisible.fullName = !collapseVisible.fullName),
                  showCurrentData()
              "
              v-if="!collapseVisible.fullName"
            >
              {{ $t("labels.change") }}
            </span>
          </div>
          <div
            v-if="collapseVisible.fullName"
            class="edit-user-block__collapse-item"
          >
            <el-input
              v-bind:class="{
                showLabel: userData.last_name || error.lastName.invalid,
                error: error.lastName.invalid,
              }"
              class="edit-user-block__input"
              :placeholder="$t('labels.surname')"
              v-model="userData.last_name"
              @blur="capitalize('last_name')"
              @input="resetError('lastName')"
            >
              <label
                v-if="error.lastName.invalid"
                class="label-error"
                slot="prefix"
              >
                {{ error.lastName.message }}
              </label>
              <label v-else slot="prefix">{{ $t("labels.surname") }}</label>
            </el-input>
            <el-input
              v-bind:class="{
                showLabel: userData.first_name || error.firstName.invalid,
                error: error.firstName.invalid,
              }"
              class="edit-user-block__input"
              :placeholder="$t('labels.name')"
              v-model="userData.first_name"
              @blur="capitalize('first_name')"
              @input="resetError('firstName')"
            >
              <label
                v-if="error.firstName.invalid"
                class="label-error"
                slot="prefix"
              >
                {{ error.firstName.message }}
              </label>
              <label v-else slot="prefix">{{ $t("labels.name") }}</label>
            </el-input>
            <el-input
              v-bind:class="{
                showLabel: userData.middle_name || error.middleName.invalid,
                error: error.middleName.invalid,
              }"
              class="edit-user-block__input"
              :placeholder="$t('labels.middle_name')"
              v-model="userData.middle_name"
              @blur="capitalize('middle_name')"
              @input="resetError('middleName')"
            >
              <label
                v-if="error.middleName.invalid"
                class="label-error"
                slot="prefix"
              >
                {{ error.middleName.message }}
              </label>
              <label v-else slot="prefix">{{ $t("labels.middle_name") }}</label>
            </el-input>
            <el-button @click="setNames" type="primary">{{
              $t("labels.save")
            }}</el-button>
            <el-button
              @click="collapseVisible.fullName = !collapseVisible.fullName"
              >{{ $t("labels.cancel") }}</el-button
            >
          </div>
        </div>

        <div v-if="!isMyProfile" class="edit-user-block">
          <div class="edit-user-block__title">
            {{ $t("students.login_data") }}
          </div>
          <template v-if="!collapseVisible.loginData">
            <div v-if="user.getLogin()" class="edit-user-block__data-row">
              <div class="edit-user-block__data-row-label">
                {{ $t("labels.login") }}
              </div>
              <div class="edit-user-block__data-row-value">
                {{ user.getLogin() }}
              </div>
            </div>
            <div v-if="user.getEmail()" class="edit-user-block__data-row">
              <div class="edit-user-block__data-row-label">
                Email
              </div>
              <div class="edit-user-block__data-row-value">
                {{ user.getEmail() }}
              </div>
            </div>
            <div v-if="user.getPhone()" class="edit-user-block__data-row">
              <div class="edit-user-block__data-row-label">
                {{ $t("labels.phone") }}
              </div>
              <div class="edit-user-block__data-row-value">
                {{ user.getMaskedPhone() }}
              </div>
            </div>
            <div class="edit-user-block__collapse-link">
              <span
                @click="
                  (collapseVisible.loginData = !collapseVisible.loginData),
                    showCurrentData()
                "
                v-if="!collapseVisible.loginData"
              >
                {{ $t("labels.change") }}
              </span>
            </div>
          </template>

          <div
            v-show="collapseVisible.loginData"
            class="edit-user-block__collapse-item"
          >
            <el-input
              v-bind:class="{
                showLabel: userData.login || error.login.invalid,
                error: error.login.invalid,
              }"
              @input="validateAuth('login')"
              class="edit-user-block__input"
              :placeholder="$t('labels.login')"
              v-model="userData.login"
            >
              <label
                v-if="error.login.invalid"
                class="label-error"
                slot="prefix"
              >
                {{ error.login.message }}
              </label>
              <label v-else slot="prefix">{{ $t("labels.login") }}</label>
            </el-input>
            <el-input
              v-bind:class="{
                showLabel: userData.email || error.email.invalid,
                error: error.email.invalid,
              }"
              @input="validateAuth('email')"
              class="edit-user-block__input"
              placeholder="Email"
              v-model="userData.email"
            >
              <label
                v-if="error.email.invalid"
                class="label-error"
                slot="prefix"
              >
                {{ error.email.message }}
              </label>
              <label v-else slot="prefix">{{ $t("labels.email") }}</label>
            </el-input>
            <div
              class="edit-user-block__input el-input el-input--prefix"
              v-bind:class="{
                showLabel: userData.phone || error.phone.invalid,
                error: error.phone.invalid,
              }"
            >
              <el-input
                v-bind:class="{
                  showLabel: error.phone.invalid,
                  error: error.phone.invalid,
                }"
                type="tel"
                name="phone"
                :placeholder="`${$t('labels.phone')}`"
                v-model="userData.phone"
                @input="validateAuth('phone')"
              >
                <label
                  v-if="error.phone.invalid"
                  class="label-error"
                  slot="prefix"
                  >{{ error.phone.message }}</label
                >
                <label v-else slot="prefix">{{ $t("labels.phone") }}</label>
              </el-input>
              <!-- <masked-input
                @input="validateAuth('phone')"
                class="el-input__inner"
                v-model="userData.phone"
                mask="\+\ 1 (111) 111-11-11"
                :placeholder="$t('labels.phone')"
              />
              <span class="el-input__prefix">
                <label v-if="error.phone.invalid" class="label-error">
                  {{ error.phone.message }}
                </label>
                <label v-else>{{ $t("labels.phone") }}</label>
              </span> -->
            </div>
            <el-button @click="setAuth" type="primary">{{
              $t("labels.save")
            }}</el-button>
            <el-button
              @click="
                (collapseVisible.loginData = !collapseVisible.loginData),
                  resetError('login, email, phone')
              "
              >{{ $t("labels.cancel") }}</el-button
            >
          </div>
        </div>

        <div class="edit-user-block">
          <div class="edit-user-block__title">
            {{ $t("labels.password") }}
          </div>
          <div
            v-if="!collapseVisible.password"
            class="edit-user-block__collapse-link"
          >
            <span @click="collapseVisible.password = !collapseVisible.password">
              {{ $t("labels.change") }}
            </span>
          </div>
          <div
            v-if="collapseVisible.password"
            class="edit-user-block__collapse-item"
          >
            <el-input
              v-if="isMyProfile"
              v-bind:class="{
                showLabel: userData.oldPassword || error.oldPassword.invalid,
                error: error.oldPassword.invalid,
              }"
              class="edit-user-block__input"
              :placeholder="$t('labels.current_password')"
              v-model="userData.oldPassword"
              type="password"
              @input="resetError('password, oldPassword')"
            >
              <label
                v-if="error.oldPassword.invalid"
                class="label-error"
                slot="prefix"
              >
                {{ error.oldPassword.message }}
              </label>
              <label v-else slot="prefix">{{
                $t("labels.current_password")
              }}</label>
            </el-input>
            <password-input
              :defaultClass="
                'edit-user-block__input' +
                  (userData.password || error.password.invalid
                    ? ' showLabel '
                    : '') +
                  (error.password.invalid ? ' error ' : '')
              "
              :invalid="error.password.invalid && error.password.message"
              v-model="userData.password"
              @input="resetError('password')"
              @hide="onPasswordHide"
              @show="onPasswordShow"
              @passwordGenerated="onPasswordGenerated"
              :placeholder="$t('labels.new_password')"
            >
            </password-input>
            <el-input
              v-bind:class="{
                showLabel:
                  userData.passwordRepeat || error.passwordRepeat.invalid,
                error: error.passwordRepeat.invalid,
              }"
              class="edit-user-block__input"
              :placeholder="$t('labels.repeat_password')"
              v-model="userData.passwordRepeat"
              :type="passwordFieldtype"
              @input="resetError('password, passwordRepeat')"
            >
              <label
                v-if="error.passwordRepeat.invalid"
                class="label-error"
                slot="prefix"
              >
                {{ error.passwordRepeat.message }}
              </label>
              <label v-else slot="prefix">{{
                $t("labels.repeat_password")
              }}</label>
            </el-input>
            <el-button @click="setPassword" type="primary">{{
              $t("labels.save")
            }}</el-button>
            <el-button
              @click="collapseVisible.password = !collapseVisible.password"
              >{{ $t("labels.cancel") }}</el-button
            >
          </div>
        </div>

        <div v-if="!isMyProfile" class="edit-user-block">
          <div class="edit-user-block__title">
            {{ $t("labels.user_status") }}
          </div>
          <template v-if="!collapseVisible.status">
            <div class="edit-user-block__data-row">
              <el-tag :type="statusToTagType(user.getStatus())">{{
                statusToTagText(user.getStatus())
              }}</el-tag>
            </div>
            <div class="edit-user-block__collapse-link">
              <span @click="collapseVisible.status = !collapseVisible.status">
                {{ $t("labels.change") }}
              </span>
            </div>
          </template>
          <div
            v-if="collapseVisible.status"
            class="edit-user-block__collapse-item"
          >
            <el-select
              class="edit-user-block__input"
              :popper-append-to-body="true"
              v-model="userData.status"
              :placeholder="$t('labels.cols.status')"
            >
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div>
              <el-button @click="setStatus" type="primary">{{
                $t("labels.save")
              }}</el-button>
              <el-button
                @click="collapseVisible.status = !collapseVisible.status"
                >{{ $t("labels.cancel") }}</el-button
              >
            </div>
          </div>
        </div>

        <div v-if="!isMyProfile" class="edit-user-block">
          <el-button
            class="edit-user-delete"
            type="text"
            icon="el-icon-delete"
            @click="deleteUser"
            >{{ $t("employees.delete") }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import auth from "@/services/auth";
import _ from "lodash";
import capitalize from "src/filters/capitalize";
import MaskedInput from "vue-masked-input";
import PasswordInput from "@/components/Authenticate/PasswordInput";
import { USER_STATUS_ACTIVE, USER_STATUS_CLOSED } from "@/constants";
import { wrapMask, normPhone } from "@/lib/phone";

const regexp = {
  login: /^[A-z0-9._-]{3,}$/,
  email: /^[A-z0-9._-]+@[A-z0-9.-]+\.[A-z]{2,4}$/,
  phone: /^[+0-9-()\s]{10,}$/,
};

export default {
  props: {
    user: Object,
    profile: {
      type: Object,
      default: null,
    },
    isMyProfile: Boolean,
  },
  components: {
    PasswordInput,
    MaskedInput,
  },
  data() {
    return {
      userData: {
        first_name: null,
        last_name: null,
        middle_name: null,
        login: "",
        email: "",
        phone: "",
        oldPassword: null,
        password: null,
        passwordRepeat: null,
        status: null,
        superadmin: null,
      },
      error: {
        login: {
          invalid: false,
          message: "",
        },
        email: {
          invalid: false,
          message: "",
        },
        phone: {
          invalid: false,
          message: "",
        },
        password: {
          invalid: false,
          message: "",
        },
        passwordRepeat: {
          invalid: false,
          message: "",
        },
        oldPassword: {
          invalid: false,
          message: "",
        },
        firstName: {
          invalid: false,
          message: "",
        },
        middleName: {
          invalid: false,
          message: "",
        },
        lastName: {
          invalid: false,
          message: "",
        },
      },
      collapseVisible: {
        fullName: false,
        loginData: false,
        password: false,
        status: false,
        superadmin: false,
      },
      passwordFieldtype: "password",
      status: [
        {
          value: USER_STATUS_ACTIVE,
          label: this.$t("labels.status_active"),
        },
        {
          value: USER_STATUS_CLOSED,
          label: this.$t("labels.status_closed"),
        },
      ],
    };
  },
  methods: {
    capitalize(path) {
      this.userData[path] = capitalize(this.userData[path]);
    },
    onPasswordHide() {
      this.passwordFieldtype = "password";
    },
    onPasswordShow() {
      this.passwordFieldtype = "text";
    },
    onPasswordGenerated(password) {
      this.userData.password = password;
      this.userData.passwordRepeat = password;
    },
    isUserSuperadmin(roles) {
      if (roles) {
        return roles.includes("superadmin");
      }
    },
    validateNames() {
      if (!this.userData.last_name) {
        this.setError("lastName", this.$t("labels.required_field"));
      } else if (!this.userData.first_name) {
        this.setError("firstName", this.$t("labels.required_field"));
      } else {
        return true;
      }
    },
    validateAuth: _.debounce(async function(authMethod) {
      let self = this;

      let errors = {
        login: {
          regexp: this.$t("labels.use_latin_symbols_and_other"),
          exists: this.$t("labels.login_exists"),
        },
        email: {
          regexp: this.$t("labels.enter_valid_email"),
          exists: this.$t("labels.email_exists"),
        },
        phone: {
          regexp: this.$t("labels.pick_valid_phone"),
          exists: this.$t("labels.phone_exists"),
        },
      };

      function isValid(authMethod, authData) {
        let reg = regexp[authMethod];
        return reg.test(authData);
      }

      function authLookup(authMethod) {
        let authData =
          authMethod === "phone"
            ? normPhone(self.userData[authMethod])
            : self.userData[authMethod];
        return info.authLookup(authData).then((data) => data);
      }

      if (!this.userData[authMethod]) {
        this.resetError("login, email, phone");
        return;
      }

      if (!isValid(authMethod, this.userData[authMethod])) {
        if (authMethod === "phone") {
          return;
        }
        this.setError(authMethod, errors[authMethod].regexp);
        return;
      }

      let authData =
        authMethod === "phone"
          ? normPhone(self.userData[authMethod])
          : self.userData[authMethod];
      let response = await auth.authLookup(authData);

      if (response && response.user_id !== self.user.getId()) {
        this.setError(authMethod, errors[authMethod].exists);
        return;
      }

      this.resetError("login, email, phone");
    }, 1000),
    validatePass() {
      function validatePass(password) {
        let regexp = /^[A-z0-9!$^&]+$/;
        return regexp.test(password);
      }
      function validatePassLength(password) {
        let regexp = /^[A-z0-9!$^&]{6,}$/;
        return regexp.test(password);
      }

      if (this.isMyProfile && !this.userData.oldPassword) {
        this.setError("oldPassword", this.$t("labels.required_field"));
      } else if (!this.userData.password) {
        this.setError("password", this.$t("labels.required_field"));
      } else if (!validatePass(this.userData.password)) {
        this.setError(
          "password",
          this.$t("labels.password_must_contain_latin_symbols_and_other")
        );
      } else if (!validatePassLength(this.userData.password)) {
        this.setError("password", this.$t("labels.min_length_password"));
      } else if (this.userData.password !== this.userData.passwordRepeat) {
        this.setError("passwordRepeat", this.$t("labels.passwords_must_match"));
      } else {
        return true;
      }
    },
    setError(key, message) {
      this.error[key].invalid = true;
      this.error[key].message = message;
    },
    resetError(keys) {
      if (keys) {
        let arr = keys.split(", ");
        for (let key of arr) {
          this.error[key].invalid = false;
          this.error[key].message = "";
        }
      } else {
        let error = this.error;

        for (let item in error) {
          this.error[item].invalid = false;
          this.error[item].mesage = "";
        }
      }
    },
    showCurrentData() {
      this.userData.first_name = this.user.getFirstName();
      this.userData.last_name = this.user.getLastName();
      this.userData.middle_name = this.user.getMiddleName();
      this.userData.login = this.user.getLogin() || "";
      this.userData.email = this.user.getEmail() || "";
      this.userData.phone = this.user.getMaskedPhone() || "";
    },
    showPassword() {
      if (this.passwordFieldtype === "password") {
        this.passwordFieldtype = "text";
      } else {
        this.passwordFieldtype = "password";
      }
    },
    statusToTagType(status) {
      switch (status) {
        case USER_STATUS_ACTIVE:
          return "success";
        default:
          return "warning";
      }
    },
    statusToTagText(status) {
      switch (status) {
        case USER_STATUS_ACTIVE:
          return this.$t("labels.status_active");
        default:
          return this.$t("labels.status_closed");
      }
    },
    async setAuth() {
      if (
        this.error.login.invalid ||
        this.error.email.invalid ||
        this.error.phone.invalid
      ) {
        console.log(
          this.$t("labels.fix_validation_errors"),
          "login",
          this.error.login.invalid,
          "email",
          this.error.email.invalid,
          "phone",
          this.error.phone.invalid
        );
      } else if (
        !this.userData.login &&
        !this.userData.email &&
        !this.userData.phone
      ) {
        this.$notify({
          // @ts-ignore
          title: this.$t("labels.check_at_least_one_auth_method"),
          type: "warning",
          offset: 75,
        });
      } else {
        try {
          let data = {
            user_id: this.user.getId(),
            login: this.userData.login || undefined,
            email: this.userData.email || undefined,
            phone: this.userData.phone || undefined,
          };
          await this.$store.dispatch("users/updateUser", data);
          this.collapseVisible.loginData = false;
          this.$emit("updateData");
        } catch (error) {
          this.$emit("updateFailed");
        }
      }
    },
    async setNames() {
      if (this.validateNames()) {
        try {
          let data = {
            user_id: this.user.getId(),
            first_name: this.userData.first_name,
            last_name: this.userData.last_name,
            middle_name: this.userData.middle_name,
          };
          await this.$store.dispatch("users/updateUser", data);
          this.collapseVisible.fullName = false;
          this.$emit("updateData");
        } catch (error) {
          this.$emit("updateFailed");
        }
      }
    },
    async setPassword() {
      if (this.validatePass()) {
        try {
          if (this.isMyProfile) {
            await this.$store.dispatch("user/setPassword", {
              old_password: this.userData.oldPassword,
              new_password: this.userData.password,
            });
          } else {
            await this.$store.dispatch("users/setPassword", {
              user_id: this.user.getId(),
              password: this.userData.password,
            });
          }
          this.collapseVisible.password = false;
          this.$emit("updateData");
          this.userData.oldPassword = "";
          this.userData.password = "";
          this.userData.passwordRepeat = "";

          if (this.isMyProfile) {
            await this.$store.dispatch("user/logout");
            this.$route.push({ name: "login" });
          }
        } catch (e) {
          console.log("LOG: setPassword -> e", e);
          let message = this.$t("labels.can_not_update_password");
          if (e.error.data.error.message === "incorrect old password") {
            message = this.$t("labels.wrong_current_password");
          }
          this.$message.error(message);
        }
      }
    },
    async setStatus() {
      if (this.userData.status) {
        try {
          await this.$store.dispatch("users/setStatus", {
            user_id: this.user.getId(),
            status: this.userData.status,
          });
          this.collapseVisible.status = false;
          this.$emit("updateData");
        } catch (error) {
          this.$emit("updateFailed");
        }
      }
    },
    async deleteUser() {
      let userName = this.user.getFullName();
      this.$confirm(userName, `${this.$t("employees.delete")}?`, {
        confirmButtonText: this.$t("labels.delete"),
        cancelButtonText: this.$t("labels.cancel"),
        customClass: "delete-modal",
      })
        .then(() => {
          this.$store.dispatch("users/removeUser", {
            user_id: this.user.getId(),
          });
          this.$router.push({ name: "users" });
          this.$message({
            type: "success",
            // @ts-ignore
            message: this.$t("employees.deleted"),
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            // @ts-ignore
            message: this.$t("employees.delete_canceled"),
          });
        });
    },
  },
};
</script>
<style lang="scss">
@import "src/assets/sass/paper/variables";
.edit-user-account {
  .Password {
    margin-bottom: 30px;
  }
}
.edit-user-delete {
  color: #ff3738 !important;
}

.edit-user-superuser-switch {
  margin-bottom: 25px;
  color: #a2a2a2;
  display: grid;
  grid-template-columns: 45px 1fr;
  grid-column-gap: 10px;

  &.active {
    color: #3e3e3e;
  }

  &__text {
    cursor: pointer;
  }
}
</style>
